import Facade from "@/Facade";
import GameStatesEnum from "@/states/GameStatesEnum";
import Signals from "@/signals/GameSignals";
import FormatData from "@/application/FormatData";
import UIFacade from "@baseUI/UIFacade";

//TODO: to UI
export default class UIPopupManager {
  constructor() {
    Signals.sessionTimeout.add(this.onSessionTimeout, this);
    Signals.continueBtnClick.add(this.onContinueBtnClick, this);
    Signals.realityCheck.add(this.realityCheckPopup, this);
    Signals.realityCheck2.add(this.realityCheckPopup2, this);
    Signals.notEnoughMoney.add(this.onNotEnoughMoneyPopup, this);
    Signals.casinoError.add(this.onCasinoError, this);
    Signals.errorConnection.add(this.onErrorServer, this);
    Signals.hardwareAcceleration.add(this.onHardwareAcceleration, this);

    document.addEventListener(
      "popupSuccessfullyShown",
      this.onPopupSuccessfullyShown.bind(this)
    );
    Facade.systemDIV = document.getElementById("system");
  }

  init() {
    Facade.model.session_total_time_start = Date.now();
    Facade.model.session_total_bet = 0;
    Facade.model.session_total_win = 0;
  }

  setBtnUnEnableSpin() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: false,
            visible: true,
          },
        },
      })
    );
  }

  setBtnEnableSpin() {
    document.dispatchEvent(
      new CustomEvent("setButtonState", {
        detail: {
          spin: {
            enable: true,
            visible: true,
          },
        },
      })
    );
  }

  returnText(paramText, initValue) {
    return (
      (Facade.textFactory &&
        Facade.textFactory.isExisted(paramText) &&
        Facade.textFactory.getTextWithStyle(paramText).text) ||
      initValue
    );
  }

  onErrorServer() {
    this.popupStatus = "errorServer";
    const title = this.returnText("connectionErrorTitle", "CONNECTION ERROR");
    const message = this.returnText(
      "connectionErrorMessage",
      "The network connection has been lost.\n Please check your internet connection or choose another network."
    );
    const button = this.returnText("connectionErrorButton", "CONTINUE");
    this.showPopup(title, message, [{ action: "continue", text: button }]);
  }

  onNotEnoughMoneyPopup() {
    this.popupStatus = "notEnoughMoney";
    const title = this.returnText("infoBalanceTitle", "INSUFFICIENT FUNDS");
    const message = this.returnText(
      "infoBalanceMessage",
      "The current balance is insufficient.\nIncrease funds to keep playing."
    );
    const button = this.returnText("infoBalanceButton", "CONTINUE");
    this.showPopup(title, message, [{ action: "continue", text: button }]);
  }

  onCasinoError() {
    this.popupStatus = "casinoError";
    const title = this.returnText("casinoErrorTitle", "CASINO ERROR");
    const message = this.returnText(
      "casinoErrorMessage",
      "Contact your casino\nif the issue persists."
    );
    const button = this.returnText("casinoErrorButton", "  OK  ");
    this.showPopup(title, message, [{ action: "continue", text: button }]);
  }

  onSessionTimeout() {
    this.popupStatus = "sessionTimeout";
    const title = this.returnText("sessionTimeoutTitle", "SESSION TIMEOUT");
    const message = this.returnText(
      "sessionTimeoutMessage",
      "The game is paused due to inactivity. Reload the page to continue."
    );
    const button = this.returnText("reload", "RELOAD");
    this.showPopup(title, message, [{ action: "reload", text: button }]);
  }

  onHardwareAcceleration() {
    this.popupStatus = "hardwareAcceleration";
    const title = this.returnText(
      "hardwareAccelerationTitle",
      "SOMETHING WENT WRONG"
    );
    const message = this.returnText(
      "hardwareAccelerationMessage",
      "Hardware Acceleration is disabled. Please enable it to continue."
    );
    const button1 = this.returnText(
      "hardwareAccelerationButtonPage",
      "PREVIOUS PAGE"
    );
    const button2 = this.returnText(
      "hardwareAccelerationButtonReload",
      "RELOAD"
    );
    this.showPopup(title, message, [
      { action: "quit", text: button1 },
      { action: "reload", text: button2 },
    ]);
  }

  realityCheck(data) {
    if (
      Facade.model.currentState != GameStatesEnum.SHOW_CYCLEWINNINGS &&
      Facade.model.currentState != GameStatesEnum.IDLE &&
      Facade.model.isFreespinsMode
    ) {
      return;
    }
    if (Facade.model.isAuto) {
      Signals.stopAutoplay.dispatch(true);
    }
    Facade.isRealityCheckPopupPendingData = null;
    // if (data.title === "Reality Check" ){this.popupStatus = 'realityCheck'}
    Facade.model.session_total_time =
      Date.now() - Facade.model.session_total_time_start;
    let hours = Math.floor(Facade.model.session_total_time / 1000 / 60 / 60);
    let minutes = Math.floor(
      (Facade.model.session_total_time / 1000 / 60) % 60
    );
    let seconds = Math.floor((Facade.model.session_total_time / 1000) % 60);
    let session_total_time_str =
      "" + hours + "h " + minutes + "m " + seconds + "s";
    let session_hours_str = "" + hours;
    let session_minutes_str = "" + minutes;
    const title =
      (data && data.title) ||
      this.returnText("realityCheckTitle", "Reality check");
    let message =
      (data && data.message) ||
      this.returnText(
        "realityCheckSupport",
        "You have been playing for" +
          " <session_hours_played> hours and <session_minutes_played> minutes. In total, you have bet" +
          " <session_total_bet> and won <session_total_win>. Would you like to keep playing?"
      );
    let session_total_time = /<session_total_time>/gi;
    let session_hours_played = /<session_hours_played>/gi;
    let session_minutes_played = /<session_minutes_played>/gi;
    let session_total_bet = /<session_total_bet>/gi;
    let session_total_win = /<session_total_win>/gi;
    let session_total_bet_str = FormatData.formatToCoins(
      Facade.model.session_total_bet
    );
    let session_total_win_str = FormatData.formatToCoins(
      Facade.model.session_total_win
    );
    message = message
      .replace(session_total_time, session_total_time_str)
      .replace(session_hours_played, session_hours_str)
      .replace(session_minutes_played, session_minutes_str)
      .replace(session_total_bet, session_total_bet_str)
      .replace(session_total_win, session_total_win_str);
    const btn_continue = this.returnText(
      "realityCheckContinue",
      "KEEP PLAYING"
    );
    const btn_quit = this.returnText("realityCheckQuit", "QUIT THE GAME");
    const buttons = (data && data.buttons) || [
      { action: "continue", text: btn_continue },
      {
        action: "lobby",
        text: btn_quit,
      },
    ];
    this.showPopup(title, message, buttons);
  }

  realityCheckPopup(data) {
    this.popupStatus = "911";
    this.realityCheck(data);
  }

  realityCheckPopup2(data) {
    this.popupStatus = "realityCheck";
    this.realityCheck(data);
  }

  onPopupSuccessfullyShown() {
    setTimeout(() => {
      this.reloadBtn = document.getElementsByClassName("reload")[0]; // Reload
      this.cancelBtn = document.getElementsByClassName("cancel")[0]; //cancelBtn
      this.continueBtn = document.getElementsByClassName("continue")[0]; //Continue_rc
      this.quitBtn = document.getElementsByClassName("quit")[0]; // Quit_rc
      this.lobbyBtn = document.getElementsByClassName("lobby")[0];

      if (this.reloadBtn) {
        this.reloadBtn.addEventListener(
          "click",
          () => {
            Signals.gameMessage?.dispatch("terminate", true);
            setTimeout(function () {
              window.location.reload(false);
            }, 1000);
          },
          false
        );
      }

      if (this.quitBtn) {
        this.quitBtn.addEventListener(
          "click",
          this.quitHandler.bind(this),
          false
        );
      }

      if (this.lobbyBtn) {
        this.lobbyBtn.addEventListener(
          "click",
          this.quitHandler.bind(this),
          false
        );
      }

      if (this.cancelBtn) {
        this.cancelBtn.addEventListener(
          "click",
          this.hidePopup.bind(this),
          false
        );
      }

      if (this.continueBtn) {
        this.continueBtn.addEventListener(
          "click",
          this.continueHandler.bind(this),
          false
        );
      }
    }, 200);
  }

  showPopup(title, message, buttons) {
    this.setBlur();
    this.setBtnUnEnableSpin();
    const divButtonsContainer = document.createElement("div");
    const buttonsContainer = document.createElement("div");
    buttonsContainer.setAttribute(
      "style",
      "display: flex; justify-content: center; flex-wrap: wrap; flex-direction: row"
    );
    for (let i = 0; i < buttons.length; i++) {
      const button = document.createElement("button");
      button.setAttribute(
        "style",
        "border-radius: 20px; height: 50px; width: 100px; text-align:center"
      );
      button.setAttribute("class", buttons[i].action);
      button.textContent = buttons[i].text;
      buttonsContainer.appendChild(button);
    }
    divButtonsContainer.appendChild(buttonsContainer);

    const data = {
      detail: {
        visible: true,
        innerhtml: `
                    <div style="background-color: rgba(0, 0, 0, .8);
                        padding: 20px;
                        width: 300px;
                        margin: auto;
                        margin-top: -150px;
                        margin-left: -150px;
                        text-align: center;
                        height: 300px;
                        color: black;
                        border-radius: 20px;
                        font-size: 12px">
                    <h1 style="text-align: center; color: #FFFFFF">${title}</h1>
                    <span style="font-size: 20px; text-align: center; color: #FFFFFF">${message}</span>
                    <br>
                    <br>
                    <br>
                    <br>        
                      ${divButtonsContainer.innerHTML}
                    </div>
               `,
      },
    };
    //document.dispatchEvent(new CustomEvent('showPopup', data))

    this.showPopupWindow(data);
  }

  quitHandler() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    Signals.gameMessage.dispatch("terminate");
    Signals.quitHandler.dispatch();
    if (Facade.model.lobbyURL) {
      window.location.replace(urlParams.get("ext_params[lobbyurl]"));
    }else{
      location.reload();
    }
  }

  continueHandler() {
    if (
      this.popupStatus !== "realityCheck" &&
      Facade.model.currentState === GameStatesEnum.GET_SPIN_RESPONSE
    ) {
      const winCombination = Facade.model.combinations;
      const fsPosition = Facade.model.freeSymbolsPosition;
      Signals.cancelSpin.dispatch(
        Facade.model.gridStages,
        winCombination,
        fsPosition
      );
    }
    this.setBtnEnableSpin();
    this.hidePopup();
  }

  onContinueBtnClick() {
    this.gameEntered = true;
  }

  hidePopup() {
    this.setUnblur();
    if (this.cancelBtn) {
      this.cancelBtn.removeEventListener(
        "click",
        this.hidePopup.bind(this),
        false
      );
    }
    if (this.continueBtn) {
      this.continueBtn.removeEventListener(
        "click",
        this.hidePopup.bind(this),
        false
      );
    }
    //
    // const event = new CustomEvent("closeCustomPopUp", {detail: {}})
    // document.dispatchEvent(event)
    this.closePopupWindow();
  }

  setBlur() {
    //   Config.app.stage.filters = [this.blurFilter]
  }

  setUnblur() {
    //  Config.app.stage.filters = null
  }

  showPopupWindow(data) {
    Facade.systemDIV.innerHTML = data.detail.innerhtml;
    document.dispatchEvent(
      new CustomEvent("popupSuccessfullyShown", { detail: {} })
    );
  }

  closePopupWindow() {
    Facade.systemDIV.innerHTML = "";
  }
}
